import { TApi } from "@/api/useApi";
import { TMutationOpts, useMutation } from "@/hooks/useMutation";
import { DownloadableReports } from "@/types/reports";
import { forceDownload } from "@/utils/download";

export async function downloadReport(api: TApi, report: DownloadableReports) {
  const response = await api.post("/internal/reports", { report }, { responseType: "blob" });
  const [, format] = response.headers["content-type"]?.split("/") ?? [];
  const [, filename] = response.headers["content-disposition"]?.split("filename=") ?? [];
  forceDownload(response.data as Blob, filename ?? `report.${format ?? "text"}`);
}

/**
 * Hook for downloading reports
 *
 * @returns Promise<void>
 */
export function useDownloadReport(opts?: TMutationOpts) {
  return useMutation<void, DownloadableReports>(downloadReport, opts);
}
